import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronDown, FiChevronUp } = FiIcons;

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  
  const faqs = [
    {
      q: "זה ייעוץ משפטי?",
      a: "לא. ברירת המחדל: מידע כללי בלבד; ייעוץ מועבר לעו״ד אנושי."
    },
    {
      q: "איך מבטיחים סודיות?",
      a: "הצפנה בתעבורה ובאחסון, הרשאות וגישה מבוקרת, תיעוד מלא ומדיניות שמירת נתונים לפי המשרד."
    },
    {
      q: "מי מלמד את הסוכן אודות המותג?",
      a: "צוות BOTLEY מפתח את הסוכן להגדרה ראשונית על פי בקשת הלקוח ועל פי מיתוג המותג."
    },
    {
      q: "מי שולט בשפה?",
      a: "אתם. אנחנו מאמנים את הסוכן לענות על פי אימון של מסמכים/אתר/טקסט של המותג."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section section bg-gray-50">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            FAQ קצר
          </h2>
        </motion.div>
        
        <div className="faq-container max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              className="faq-item bg-white rounded-2xl shadow-lg mb-4 overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <button
                className="faq-question w-full p-6 text-right flex items-center justify-between hover:bg-gray-50 transition-colors"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-lg font-semibold text-gray-900">{faq.q}</span>
                <SafeIcon 
                  icon={openIndex === index ? FiChevronUp : FiChevronDown}
                  className="text-purple-600 flex-shrink-0"
                />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="faq-answer overflow-hidden"
                  >
                    <div className="p-6 pt-0 text-gray-600 leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;